// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_3+mbaIDoXUndWAJHlC5-xw==","Copyright":"Abe2bRqti-Y9g92ZGcWqxQ==","Logo":"G4Zt1vKgsIlqMP9jfPO8Yw==","Links":"dwMlANV5Yj8Ovqmv-I9Utg=="};